<template>
  <div class="gift-tracker-tab">
    <div v-if="registrantErrorState || giftTrackerResultsError || giftTrackerResultsErrorMsg" class="grid-x margin-top-xs margin-bottom-xl">
      <AtomicUiNotification class="cell small-12 medium-7" severity="error" :closable="false">
        {{ registrantErrorState ? errorMessages.giftTracker : giftTrackerResultsErrorMsg }} <br />
        <button class="try-again" @click="getTrackerResultsWithDefault">Refresh</button>
      </AtomicUiNotification>
    </div>
    <RegistrantGiftTrackerTable v-else @get-registrant-gift-tracker-results="getRegistrantGiftTrackerResults" />
  </div>
</template>

<script setup>
import { fireTag } from '@nuxt-common/util/app/utils/tagManager';
import { errorMessages } from 'config';
import { useAssociation } from '~/composables/useAssociation';
import { useRegistrantGiftTrackerStore } from '~/stores/registrantGiftTracker';
import { useEnvPropsStore } from '~/stores/envProps';
import { useBaseStore } from '~/stores/base';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
const RegistrantGiftTrackerTable = defineAsyncComponent(() => import('~/components/RegistrantGiftTracker/RegistrantGiftTrackerTable'));

const { registryGUID } = useAssociation();
const registrantGiftTrackerStore = useRegistrantGiftTrackerStore();
const envPropsStore = useEnvPropsStore();
const baseStore = useBaseStore();
const registrantErrorState = computed(() => registrantGiftTrackerStore.errorState);
const giftTrackerResultsError = computed(() => registrantGiftTrackerStore.giftTrackerResultsError);
const giftTrackerResultsErrorMsg = ref(null);

const orgId = computed(() => (envPropsStore.envProps.entryPoint.toUpperCase() === 'MCOM' ? 12 : 13));
const orderStatusEnabledKS = computed(() => baseStore.orderStatusEnabledKS);

const getRegistrantGiftTrackerResults = async (purchasePagination) => {
  giftTrackerResultsErrorMsg.value = null;
  await registrantGiftTrackerStore
    .getRegistrantGiftTrackerResults({
      orgId: orgId.value,
      registryGUID: registryGUID.value,
      purchaseFlag: true,
      filterFlag: true,
      addressFlag: false,
      eSend: false,
      headerFlag: true,
      pagInfo: false,
      preferenceFlag: false,
      registrantFlag: false,
      sellStoreNumber: 1,
      orderInfoFlag: orderStatusEnabledKS.value,
      purchasePagination,
    })
    .then((res) => {
      const error = res?.response?.data?.errors || res?.response?.data?.error || res?.data?.errors || res?.data?.error;
      if (error || giftTrackerResultsError.value) {
        giftTrackerResultsErrorMsg.value = error?.[0]?.description || errorMessages.giftTrackerApiError;
        fireTag('link', {
          event_name: 'Registry error',
          error_category: 'registry',
          error_code: [`REG${error?.[0]?.code || '999'}`],
          error_label: [''],
          error_message: [giftTrackerResultsErrorMsg.value],
          error_misc: [' '],
          error_scope: ['Global'],
        });
      }
    });
};

const getTrackerResultsWithDefault = () => {
  const purchasePagination = {
    sortColumn: 'sortByDate',
    sortOrder: 'desc',
    pageSize: 10,
    pageNumber: 1,
  };
  getRegistrantGiftTrackerResults(purchasePagination);
};
onMounted(() => {
  navigateTo({ query: { tab: 'tracker' } }, { replace: true });
  getTrackerResultsWithDefault();
  fireTag('view', {
    page_name: 'registry Gift Tracker',
    page_type: 'registry',
  });
});
</script>

<style lang="scss" scoped>
.giftTrackerTab {
  position: inherit;
}
</style>
